var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"layer1","transform":"translate(-164.991,-200.04762)"},React.createElement("g",{"id":"g3514","transform":"matrix(4.8104881,0,0,4.1794047,3.2672039,110.24893)"},[React.createElement("rect",{"id":"rect3498","width":"56.292","height":"5","x":"33.618999","y":"26.486","key":0}),React.createElement("rect",{"id":"rect3502","width":"56.292","height":"5","x":"33.618999","y":"48.159","key":1}),React.createElement("rect",{"id":"rect3506","width":"40","height":"5","x":"33.618999","y":"70.974998","key":2})])));
}

Menu.defaultProps = {"width":"76.423515mm","height":"70.306519mm","viewBox":"0 0 270.79198 249.11758","id":"svg2","version":"1.1"};

module.exports = Menu;

Menu.default = Menu;
